import { useRecomputeDismissReviewModal } from '@/modules/Project/Fields/RecomputeDismissReviewModal.vue'
import { useLimitedAction } from '../Billing/useLimitedAction'
import type { Field } from './Fields/types'
import { useEntity } from './useEntity'
import { useProjectStore } from './useProjectStore'

export const useFieldRecompute = () => {
  const projectStore = useProjectStore()
  const entityStore = useEntity()
  const { recalculateEntity } = useLimitedAction()
  const { setOpen: openDismissReviewModal } = useRecomputeDismissReviewModal()

  const recomputeField = async (field: Field) => {
    if (field.status === 'computing') return

    if (field.reviewStatus === 'approved' || field.reviewStatus === 'rejected') {
      openDismissReviewModal(field)
      return
    }

    const originalStatus = field.status
    const optimisticField = { ...field, status: 'computing' as const }

    entityStore.updateField(optimisticField)
    projectStore.updateField(optimisticField)

    const res = await recalculateEntity({
      workspaceId: field.workspaceId,
      projectId: field.projectId,
      entityId: field.entityId,
      propertyIds: [field.propertyId],
      force: true,
    })

    if (!res.ok) {
      const revertField = { ...field, status: originalStatus }
      entityStore.updateField(revertField)
      projectStore.updateField(revertField)
    }
  }

  return { recomputeField }
}
